import React from 'react';
import TextField from '../shared/ppbn-textfield';
import '../../styles/createInvoice.css'
import { withStyles } from '@material-ui/core/styles';
import CurrencyInput from '../shared/CurrencyInput';

const styles = theme => ({
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },    
    textField: {
      marginLeft: 20,
      marginTop: 15,      
      marginRight: theme.spacing.unit,
      width: 200,
    },
    paymentTypeContainer: {
        paddingLeft: 20,
        paddingTop: 10,
        paddingBottom:10
    },
    serviceNotes: {
      marginLeft: 20,  
      marginRight: theme.spacing.unit,
      width: '655px',
    },
    menu: {
      width: 200,
    },
  });

class LoadInvoiceForm extends React.Component {            

    dateChanged = (id, value) => {
        this.props.handleChange({ target : { id, value } })
    }           

    paymentAndChargeDetails() {        
        const { handleChange, classes } = this.props;
        return (
            <div className="payments">
                <div className='invoice-sub-header'>Payment and Charge Details</div>                
                <div className="payment-details">                                        
                    <CurrencyInput
                        id='timeCharges'
                        type="number"
                        value={this.props.timeCharges}
                        className={classes.textField}
                        label='Time Charges'
                        onChange={handleChange} />                    
                    <CurrencyInput
                        id='dockFees'
                        type="number"
                        value={this.props.dockFees}
                        className={classes.textField}
                        label='Dock Fees'
                        onChange={handleChange} />
                    <CurrencyInput
                        id='additionalCharges'
                        type="number"
                        value={this.props.additionalCharges}
                        className={classes.textField}
                        label='Additional Charges'
                        onChange={handleChange} />
                    <CurrencyInput
                        id='credits'
                        type="number"
                        value={this.props.credits}
                        className={classes.textField}
                        label='Credits'
                        onChange={handleChange} />
                    <TextField
                        value={this.props.paymentDate || ''}
                        label="Payment Date"
                        id='paymentDate'
                        InputLabelProps={{ shrink: true, }}
                        className={classes.textField}
                        onChange={(e) => this.dateChanged('paymentDate', e.target.value)}
                        type="date" />
                    <CurrencyInput
                        id='postedToReceivables'
                        type="number"
                        value={this.props.postedToReceivables}
                        className={classes.textField}
                        label='Posted To Receivables'
                        onChange={handleChange} />
                    <CurrencyInput
                        type="number"
                        id='invoiceTotal'
                        value={this.props.invoiceTotal}
                        className={classes.textField}
                        label='Invoice Total'
                        onChange={handleChange} />
                </div>      
            </div>
        )
    }

    render() {
        const { handleChange, classes, invoiceId } = this.props;        
        return (
            <div className="invoice-form-container">
                <div className='invoice-sub-header'>    
                    <div>General Details {invoiceId ? <span className='invoice-sub-header-invoice-number'>(Editing Invoice: {`S${invoiceId}`})</span>: null}</div>                  
                </div>
                <TextField
                    id="location"
                    value={this.props.location || ""}    
                    inputProps={ {maxLength : 45}}
                    className={classes.textField}
                    label="Location"
                    onChange={handleChange}
                    margin="normal"
                />
                <TextField
                    id="unit"       
                    className={classes.textField}
                    value={this.props.unit || ""}                    
                    inputProps={ {maxLength : 20}}
                    label="Unit"
                    onChange={handleChange}
                    margin="normal"
                />                
                <TextField
                    value={this.props.date || ''}
                    label="Date"
                    id='date'
                    InputLabelProps={{ shrink: true, }}
                    className={classes.textField}                    
                    onChange={(e) => this.dateChanged('date',e.target.value)}
                    type="date" />        
                <TextField
                    id="contents"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    value={this.props.contents || ""}
                    className={classes.textField}
                    inputProps={ {maxLength : 140}}
                    label="Contents"
                    onChange={handleChange}/>
                <TextField
                    id="loadNumber"
                    value={this.props.loadNumber || ""}
                    className={classes.textField}
                    inputProps={ {maxLength : 20}}
                    label="Load Number"
                    onChange={handleChange}
                    margin="normal"
                />                
                <TextField
                    id="companyPO"
                    value={this.props.companyPO || ""}                    
                    inputProps={ {maxLength : 140}}                    
                    className={classes.textField}
                    label="Company PO"
                    onChange={handleChange} />
                <TextField
                    id="referenceNumber"
                    value={this.props.referenceNumber || ""}                    
                    inputProps={ {maxLength : 20}}
                    className={classes.textField}
                    label="Reference Number"
                    onChange={handleChange} />                
                <br />
                <br />
                <TextField
                    id='serviceNotes'                    
                    inputProps={ { maxLength : 1000 } }
                    value={this.props.serviceNotes}                    
                    className={classes.serviceNotes}
                    label='Service Notes'
                    rows={3}
                    rowsMax={5}
                    multiline={true}
                    variant="outlined"
                    onChange={handleChange} />                
                {this.paymentAndChargeDetails()}                 
            </div>
          )
    }
}

export default withStyles(styles)(LoadInvoiceForm);
